import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=067f97da&scoped=true"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"
import style0 from "./Legal.vue?vue&type=style&index=0&id=067f97da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f97da",
  null
  
)

export default component.exports